var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirmation_number_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FoodCoupons; Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.48 6 12ZM13 7H11V9H13V7ZM11 11H13V13H11V11ZM13 15H11V17H13V15Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "FoodCoupons; Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6V10C20.9 10 20 10.9 20 12C20 13.1 20.9 14 22 14V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V14C3.11 14 4 13.1 4 12C4 10.9 3.11 10 2.01 10V6C2.01 4.89 2.9 4 4 4H20C21.1 4 22 4.89 22 6ZM18 12C18 10.53 18.81 9.23 20 8.54V6H4L4.01 8.54C5.2 9.23 6 10.52 6 12C6 13.47 5.19 14.77 4 15.46V18H20V15.46C18.81 14.77 18 13.47 18 12Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "FoodCoupons; Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    d: "M11 15H13V17H11V15Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "FoodCoupons; Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M11 11H13V13H11V11Z",
    fill: "white",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "FoodCoupons; Dark Color_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    d: "M11 7H13V9H11V7Z",
    fill: "white",
    fillOpacity: 0.54
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.8732763ccb6000e8bf4c62b929c3f80c.svg";
export { ForwardRef as ReactComponent };